import * as z from 'zod';

import { AudienceOrderType } from 'types/api/audience/enums';

export const AudienceOrderTypeSchema = z.object({
  description: z.string().optional(),
  id: z.nativeEnum(AudienceOrderType),
  name: z.string().optional().nullish(),
});

export type IAudienceOrderType = z.infer<typeof AudienceOrderTypeSchema>;
